/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilitiesOverBuildWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilitiesOverBuildWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilitiesOverBuildWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilitiesOverBuildWidgetConfiguration>): VulnerabilitiesOverBuildWidgetConfiguration {
        let obj = Object.assign(new VulnerabilitiesOverBuildWidgetConfiguration(), model);
        VulnerabilitiesOverBuildWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilitiesOverBuildWidgetConfiguration>): VulnerabilitiesOverBuildWidgetConfiguration {
        if (!model) return null;
        return VulnerabilitiesOverBuildWidgetConfiguration.newInstance(<VulnerabilitiesOverBuildWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilitiesOverBuildWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilitiesOverBuildWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilitiesOverBuildWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilitiesOverBuildWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
